import { asyncScope, isValidKey, type KeyFilter } from "./utils";
import type { NavigationRaw } from "..";
import type { NexusHandler } from "../../nexus/function/function.types";
import { defineContext, historyPatched } from "./history.client";
import { navigateCrossDocument } from "./navigation.client";
import { baseLocation } from "./location";
import type { NaviagationMergeOptions } from "./navigation.types";
import {
  fromStringParams,
  mergeParamCache,
  paramTypes,
  toStringParams,
} from "../params/params.utils";

const log = asyncScope.scope("navigate");

export const normalizeFilters = (param: true | KeyFilter[]): KeyFilter[] => {
  if (param === true) return [];
  return param;
};

/**
 *
 *
 *
 *
 *
 *
 */
export const mergeUrl = (
  url: URL,
  mergeOptions: NaviagationMergeOptions,
  base = baseLocation,
): URL => {
  /*            */
  if (!mergeOptions.search && !mergeOptions.hash) return url;

  for (const key of paramTypes) {
    /*                           */
    const mergeOpt = mergeOptions[key];
    if (!mergeOpt) continue;

    /*                                                                                 */
    if (mergeOpt === true && url[key].length < 2) {
      url[key] = base[key];
    } else {
      /*                                          */
      const merged = mergeParamCache(
        fromStringParams(base[key], normalizeFilters(mergeOpt)),
        fromStringParams(url[key]),
        [],
        new Set(),
      );
      url[key] = toStringParams(merged);
    }
  }

  return url;
};

/**
 *
 *
 *
 *
 *
 *
 */
export const mergeState = (
  state: Record<string, unknown> | undefined,
  mergeOptions: NaviagationMergeOptions,
  base: Record<string, unknown> | undefined | null,
): Record<string, unknown> | undefined => {
  /*                                                                          */
  if (!mergeOptions.state || typeof base !== "object" || base === null) return state;

  /*                                                                                           */
  if (mergeOptions.state === true && !state) return base;

  /*                        */
  const filters = normalizeFilters(mergeOptions.state);
  const res = state ?? {};

  /*                                                       */
  /*                                           */
  for (const [key, value] of Object.entries(base)) {
    if (res[key] !== undefined || !isValidKey(key, filters)) continue;
    res[key] = value;
  }

  return res;
};

/**
 *
 */
export const navigate: NexusHandler<NavigationRaw["navigate"]> = async (
  urlOrString = "",
  o = {},
) => {
  const { history: navigationType = "push", state, info } = o;
  log.debug("Navigation request:", navigationType, "for:", urlOrString, "with options", o);

  /*                                                       */
  const nextUrl = new URL(urlOrString, baseLocation.origin);
  /*                                                  */
  if (nextUrl.hash.length < 2) nextUrl.hash = "";

  if (o.merge) {
    mergeUrl(nextUrl, o.merge);
  }

  /*                                          */
  if (navigationType === "document") return navigateCrossDocument(nextUrl, info);

  const hist = await historyPatched();
  if (o.merge) {
    mergeState(state, o.merge, hist.state);
  }

  /*                                                                */
  const method = hist[`${navigationType}State`];
  if (!method) return false;

  /*                                                           */
  log.info("Navigate to", nextUrl.href, "as", navigationType, "with state", state);
  method.call(defineContext({ ...o }), state, "", nextUrl);
  return true;
};
